/**
 * Content Utility Functions
 *
 * Collection of pure utility functions for content manipulation and calculations.
 * These functions are stateless and can be used across different components.
 *
 * @module utils/content-utils
 */

/**
 * Calculates estimated reading time for a given text content
 * Based on average reading speed of 225 words per minute
 *
 * @param content - HTML string to calculate reading time for
 * @returns Number of minutes to read the content
 */
// eslint-disable-next-line import/prefer-default-export
export const calculateReadingTime = (content: string): number => {
  // Strip HTML tags
  const text = content.replace(/<[^>]*>/g, "");

  // Count words (split by whitespace)
  const words = text.trim().split(/\s+/).length;

  // Calculate minutes based on 225 words per minute
  const minutes = Math.ceil(words / 225);

  // Return at least 1 minute
  return Math.max(1, minutes);
};

export default calculateReadingTime;

export const stripTags = (str: string) => str.replace(/<[^>]+>/g, "");

export const removeFirstPTag = (html?: string | null): string =>
  (html ?? "").replace(/^<p\b[^>]*>([\s\S]*?)<\/p>/i, "$1");

export const stripBoldItalicTags = (html: string): string => html.replace(/<\/?[bi]>/gi, "");

export const removeDash = (str: string): string => str.replace(/^- /, "");